// TODO frha: Move the error component to be reusable across apps
import { Component } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: true,
  imports: [],
})
export class ErrorComponent {}
